export const blogPosts = [
  {
    title: 'Expose local service securely to the internet using Cloudflare Tunnels',
    url: 'https://medium.com/@shingalaanirudh/expose-local-service-securely-to-internet-using-cloudflare-tunnels-f2f82b0f066e',
    tag: 'Cloudflare'
  },
  {
    title: 'Load balance workload using Nginx and set up SSL for secure connection',
    url: 'https://medium.com/@shingalaanirudh/loadbalance-workload-using-nginx-and-setup-ssl-for-secure-connection-9650a4fd7e0f',
    tag: 'Nginx'
  },
  {
    title: 'Publish your application as a custom public Helm chart on GitHub',
    url: 'https://medium.com/@shingalaanirudh/publish-your-application-as-custom-public-helm-chart-on-github-730bbe7ee1a0',
    tag: 'Helm'
  },
  {
    title: 'Backup and restore etcd data in a Kubernetes cluster',
    url: 'https://medium.com/@shingalaanirudh/backup-and-restore-etcd-data-in-kubernetes-cluster-24a0d0f4d3dc',
    tag: 'Kubernetes'
  },
  {
    title: 'Deploy a Kubernetes cluster on AWS EC2 in ~10 minutes using kubeadm',
    url: 'https://medium.com/@shingalaanirudh/deploy-kubernetes-cluster-on-aws-ec2-instances-in-10-mins-using-kubeadm-35ed1e882fa7',
    tag: 'AWS'
  }
];
